import React, {
  useEffect,
  useMemo, useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { IoChevronUpOutline, IoChevronDownOutline } from 'react-icons/io5';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  Row,
} from '@tanstack/react-table';
import styles from './clients-table.module.scss';
import { IClient } from '~/types/clients';

const columns = [{
  header: 'Référence',
  accessorKey: 'ref',
}, {
  header: 'Nom de la société',
  accessorKey: 'name',
  cell: ({ row }: any) => {
    const client = row.original;
    return (
      <div>
        { client.name } { !client?.ref ? <span style={{ color: '#EC5E52' }}> - client hors Sage</span> : null }
      </div>
    );
  },
}, {
  header: 'Ville',
  accessorKey: 'city',
}, {
  header: 'Nombre de devis associés',
  accessorKey: 'estimates',
}];

const ClientsTable = (
  {
    clients,
    handleSorting,
    baseTo = '/clients',
  } : {
    clients: IClient[],
    handleSorting?: any,
    baseTo?: string,
  },
) => {
  const [sorting, setSorting] = useState<any>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof handleSorting === 'function') handleSorting(sorting[0] || null);
  }, [sorting]);

  const data = useMemo(() => clients, [clients]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    onSortingChange: setSorting,
    state: {
      sorting,
    },
  });

  const onRowClick = (row: Row<IClient>) => {
    navigate(`${baseTo}/${row.original._id}`);
  };

  return (
    <div className={styles.clientsTable}>
      <table>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                >
                 <p>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                  {typeof header.column.getIsSorted() === 'string' ? (
                    {
                      asc: IoChevronUpOutline({}),
                      desc: IoChevronDownOutline({}),
                    }[header.column.getIsSorted() as string]
                  ) : (
                    <span className={styles.sortIcons}>
                      {IoChevronUpOutline({})}
                      {IoChevronDownOutline({})}
                    </span>
                  )}
                 </p>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} onClick={() => onRowClick(row)}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>
                  <div className={`${styles.cell} ${styles[cell.column.id]}`}>
                    <div className={styles.content}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </div>
                  </div>
              </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClientsTable;
